<template>
  <div>
    <section class="store">
      <div class="store__header">
        <div class="store__header__content">
          <h1>{{ getTranslations.home_store_store }}</h1>
        </div>
      </div>
      <div class="store__content">
        <div class="store__content__head">
          <h2>{{ getTranslations.home_store_buy_games }}</h2>
        </div>
        <div :class="['store__content__list ', storedBundles.length > 0 ? '' : ' store_empty' ]">
         <span class="empty_msg">{{ getTranslations.home_store_no_bundles }}</span>
          <ul>
            <li v-for="(storeItem, index) in orderedStoreItems" :key="index">
              <div><span class="boldspan">
                {{ storeItem.noOfGames?storeItem.noOfGames +' '+ getTranslations.home_store_games :'' }}
               {{storeItem.noOfGames && storeItem.points?getTranslations.home_store_and :''}}
               {{storeItem.points?storeItem.points +' '+ getTranslations.home_store_points:''}}
                {{ getTranslations.home_store_for }}</span><span> {{ storeItem.price
                }} {{ storeItem.currencyCode }}</span></div>
              <a :style="{ cursor: 'pointer' }"
                 :class="[ 'btn2 btn2--std btn2--small', { 'deactivated' : buyInProgress } ]"
                 @click.prevent="getIt(storeItem.bundleId, storeItem.noOfGames, storeItem.price, storeItem.currencyCode, storeItem.points)">
                {{ getTranslations.home_store_get_it }}</a>
            </li>
            <li v-if="facebookFunctionality" class="fb_share">
              <div><span class="boldspan">1 {{ getTranslations.home_store_game}} {{ getTranslations.home_store_for }} </span><span>{{ getTranslations.home_store_ref_friend }}</span></div>
              <a class="fb_btn btn--icon" @click.prevent="shareFriendsInvitation()" style="cursor:pointer"><i class="icon-facebook"></i><span>{{ getTranslations.home_store_share }}</span></a>
            </li>
          </ul>
          <span class="fb_error_msg" v-if="fb_error">{{ getTranslations.home_store_this_fb }}</span>
          <span v-if="vatBanner" class="store_note">{{ getTranslations.home_store_vat }}</span>
        </div>
      </div>
      <!-- dynamically change modals -->
      <component :is="modalForStore" @bundlePurchase="bundlePurchase"></component>
    </section>
  </div>
</template>

<script>
  /* eslint no-console: "off", no-param-reassign: ["error", { "props": false }], no-use-before-define: ["error", { "variables": false }] */

import { mapGetters, mapActions, mapState, mapMutations } from 'vuex';
import FacebookMixin from '@/common/mixins/facebookIntegration';
import ResubscribeGame from './modals/ResubscribeGame';
import ResubscribeGameSms from './modals/ResubscribeGameSms';
import ConfirmPurchase from './modals/ConfirmPurchase';
import ConfirmPurchaseForPin from './modals/ConfirmPurchaseForPin';
import ConfirmPurchaseForPinError from './modals/ConfirmPurchaseForPinError';
import ConfirmPurchaseViaSms from './modals/ConfirmPurchaseViaSms';

export default {
  name: 'store',
  mixins: [FacebookMixin],
  data() {
    return {
      points: '',
      action: 'invitation',
      fb_error: false,
      showedModal: false,
      redirectUrl: '',
      buyInProgress: false,
    };
  },
  created() {
    this.redirectUrl = `${window.location.href}/${this.getLocale || localStorage.getItem('locale')}/`;
    if (this.facebookFunctionality) {
      this.forceFbToScrapNewMetadata(this.redirectUrl, () => {
        // eslint-disable-next-line
        console.log('successful scrapping!');
      });
    }
  },
  mounted() {
    // init google analytics (from the imported mixin)
    this.storedBundlesCall();
  },
  methods: {
    ...mapActions('profile', [
      'requestPin',
      'storedBundlesCall',
      'getUserLoginDetails',
    ]),
    ...mapMutations('profile', [
      'setBundleId',
      'setBundleData',
    ]),
    ...mapMutations('common', [
      'storeModalForStore',
    ]),
    bundlePurchase() {
      this.getUserLoginDetails();
    },
    showError() {
      this.fb_error = true;
    },
    shareFriendsInvitation() {
      this.fb_error = false;
      this.share(
        this.userDetails.facebookId,
        this.userDetails.id,
        () => { console.log('successful share invitation!'); },
        this.showError,
      );
    },
    showModal() {
      /* eslint-disable */
      this.$nextTick(() => {
        // vm for instance of vue, and in it, the this is for window so the next line is necessary
        // open modal
        $('.modal,.modal-overlay').fadeIn(200);
        // show/hide modal
        $('.modal-close, .modal-overlay').click(() => {
          $('.modal, .modal-overlay').fadeOut();
          if (!this.showedModal) {
            this.showedModal = true;
            this.storeModalForStore(null);
          } else {
            this.storeModalForStore(null);
          }
        });
      });
      /* eslint-enable */
    },
    getIt(bundleId, numberOfGames1, price1, currencyCode1, points1) {
      this.buyInProgress = true;
      this.getUserLoginDetails().then(() => {
        if (this.purchaseBundleFromUnsubUser) {
          this.getBundle(bundleId, numberOfGames1, price1, currencyCode1, points1);
        } else {
          // eslint-disable-next-line
          if (!this.userDetails.subscribed) {
            if (this.subAndUnsubViaSMS) {
              if (this.reoptinAndOptoutConfig === 'REOPTIN_SMS' || this.reoptinAndOptoutConfig === 'REOPTIN_OPTOUT_SMS') {
                this.storeModalForStore(ResubscribeGameSms);
              } else {
                this.storeModalForStore(ResubscribeGame);
              }
            } else {
              this.storeModalForStore(ResubscribeGame);
            }
            this.buyInProgress = false;
            this.showModal();
          } else {
            this.getBundle(bundleId, numberOfGames1, price1, currencyCode1, points1);
          }
        }
      });
    },
    getBundle(bundleId, numberOfGames1, price1, currencyCode1, points1) {
      this.setBundleId(bundleId);
      const bundleData = {
        numberOfGames: numberOfGames1,
        price: price1,
        currencyCode: currencyCode1,
        points: points1,
      };
      this.setBundleData({ bundleDataObject: bundleData });
      if (this.purchaseViaSMS) {
        this.buyInProgress = false;
        this.storeModalForStore(ConfirmPurchaseViaSms);
        this.showModal();
      } else {
        // eslint-disable-next-line
        if (this.pinForBundles) {
          const bundleInfo = {
            bundleId: this.bundleId,
          };
          this.requestPin({ value: bundleInfo }).then(() => {
            this.buyInProgress = false;
            if (this.requestPinResponse === 'OPERATION_SUCCESS') {
              this.storeModalForStore(ConfirmPurchaseForPin);
              this.showModal();
            } else {
              this.storeModalForStore(ConfirmPurchaseForPinError);
              this.showModal();
            }
          });
        } else {
          this.storeModalForStore(ConfirmPurchase);
          this.showModal();
        }
      }
    },
  },
  computed: {
    ...mapState('common', [
      'purchaseBundleFromUnsubUser',
      'facebookFunctionality',
      'subAndUnsubViaSMS',
      'reoptinAndOptoutConfig',
      'pinForBundles',
      'purchaseViaSMS',
      'modalForStore',
      'userDetails',
      'vatBanner',
    ]),
    ...mapState('profile', [
      'storedBundles',
      'requestPinResponse',
      'bundleId',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
      'getLocale',
    ]),
    orderedStoreItems() {
      // sort items by date ascending
      return this.storedBundles.slice(0).sort((a, b) => a.price - b.price);
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/components/home/Store.vue